import { Navigate } from "react-router";
import { useAuth } from "@/auth";
import { Loader2 } from "lucide-react";

type Props = {
  children: React.ReactNode;
};

const AdminRoute = ({ children }: Props) => {
  const { isAuthenticated, hasBackendAccount, isAdmin, loading } = useAuth();

  const isLoading = loading;

  if (isLoading) {
    return (
      <div className="container mx-auto py-6 md:py-8 min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
              <Loader2 className="h-8 w-8 text-primary animate-spin" />
            </div>
          </div>
          <div>
            <h2 className="text-heading-lg font-bold text-foreground mb-2">Verifying Access</h2>
            <p className="text-body-md text-muted-foreground">
              Please wait while we check your permissions...
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !hasBackendAccount) {
    return <Navigate to="/sign-up" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
